const Module = () => import('./Module.vue')
const Chatbot = () => import('./views/Chatbot.vue')
const AdminDashboard = () => import('./views/AdminDashboard.vue')

// No meta.requiresAuth: the chatbot page is open for now (auth comes later).
const moduleRoute = {
  path: '/chatbot',
  component: Module,
  children: [
    {
      name: 'Chatbot',
      path: '',
      component: Chatbot
    },
    {
      // Settings dashboard: edit context-pack behaviour + manage knowledge files.
      name: 'ChatbotSettings',
      path: 'settings',
      component: AdminDashboard
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
